import React, { Component } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Route, Switch, BrowserRouter } from "react-router-dom";
// import PrivateRoute from './PrivateRoute'
import {
  Home,
  Profile,
  Journal,
  Programs,
  Questionnaire,
  PasswordForgotten
} from "../../screens";
import store from "../../config/store";

class Routes extends Component {
  render() {
    const userLoggedIn = !!store.getState().user.payload.token;
    return (
      <div className="wrapall">
        <BrowserRouter>
          <Route
            render={({ location }) => (
              <TransitionGroup>
                <CSSTransition
                  key={location.key}
                  classNames="fade"
                  enter
                  leave
                  timeout={300}
                  unmountOnExit
                >
                  <Switch location={location}>
                    <Route
                      exact
                      path="/"
                      component={userLoggedIn ? Journal : Home}
                    />
                    <Route
                      exact
                      path="/password-forgotten"
                      component={PasswordForgotten}
                    />
                    <Route
                      exact
                      path="/journal"
                      component={userLoggedIn ? Journal : Home}
                    />
                    <Route
                      exact
                      path="/profile"
                      component={userLoggedIn ? Profile : Home}
                    />
                    <Route
                      exact
                      path="/programs"
                      component={userLoggedIn ? Programs : Home}
                    />
                    <Route
                      exact
                      path="/questionnaire/:id?"
                      component={Questionnaire}
                    />
                  </Switch>
                </CSSTransition>
              </TransitionGroup>
            )}
          />
        </BrowserRouter>
      </div>
    );
  }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/components/routes/Routes.js